import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);    // null = checking, false = not authed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/api/auth/me`, { withCredentials: true })
      .then((r) => { setUser(r.data); setLoading(false); })
      .catch(() => { setUser(false); setLoading(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
    setUser(data);
    return data;
  };

  const register = async (name, email, password, phone) => {
    const { data } = await axios.post(`${API}/api/auth/register`, { name, email, password, phone }, { withCredentials: true });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
